import { render, staticRenderFns } from "./SeasonalBackground.vue?vue&type=template&id=48c5a250&scoped=true"
import script from "./SeasonalBackground.vue?vue&type=script&lang=js"
export * from "./SeasonalBackground.vue?vue&type=script&lang=js"
import style0 from "./SeasonalBackground.vue?vue&type=style&index=0&id=48c5a250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c5a250",
  null
  
)

export default component.exports